import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-privacy-policy-sk',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './privacy-policy-sk.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicySkComponent {
  @Input() effectiveDate!: string;
  @Input() version!: string;
  @Input() supportEmail!: string;
  @Input() websiteUrl!: string;
  @Input() jobPortalUrl!: string;
}
